import React from 'react'
import clsx from 'clsx'
import { useRouter } from 'next/router'

import { Text } from '@wartek-id/text'

import { MILKvKeys, useGetKeyPairValue } from 'api/microlearning/useAPIKeyValue'
import { sanitizeAndFormatHTML } from 'app/KinerjaPSPegawaiPage/utils/html'

const KMDisclaimer = (props: { className?: string }) => {
  const { data } = useGetKeyPairValue<{
    documentIds: string[]
    topicIds: string[]
    content: string | null
  }>(MILKvKeys.KMDisclaimer, true, {
    staleTime: Infinity,
  })
  const router = useRouter()
  const shouldShowDisclaimer =
    data?.data?.documentIds?.findIndex((id) => id === router?.query?.id) > -1
  if (!data?.data?.content || !shouldShowDisclaimer) return null
  return (
    <Text
      className={clsx(props.className)}
      variant="helper"
      color="subdued"
      dangerouslySetInnerHTML={{
        __html: sanitizeAndFormatHTML(data.data.content, false),
      }}
    />
  )
}

export default KMDisclaimer
